/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
`
export default class ChatBubbleIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21.991" viewBox="0 0 22 21.991" css={Color} className="chat-bubble">
        <path id="패스_6725" className="fill" data-name="패스 6725" d="M780.841-546.674c.145-.877.282-1.715.421-2.553.1-.615.213-1.229.306-1.846a.565.565,0,0,0-.071-.332,10.966,10.966,0,0,1-1.388-6.58,10.755,10.755,0,0,1,1.907-5.152,10.912,10.912,0,0,1,4.566-3.783,10.8,10.8,0,0,1,4.915-.94,10.76,10.76,0,0,1,5.534,1.763,10.893,10.893,0,0,1,4.211,5.1,10.762,10.762,0,0,1,.75,5.241,10.763,10.763,0,0,1-1.962,5.223,10.89,10.89,0,0,1-4.569,3.732,10.883,10.883,0,0,1-5.276.892,11.127,11.127,0,0,1-4.619-1.416.6.6,0,0,0-.362-.053c-1.339.216-2.676.444-4.014.667C781.093-546.7,780.994-546.692,780.841-546.674Z" transform="translate(-780.052 567.87)" fill="#eee"/>
      </svg>
    )
  }
}
